import React, { memo } from 'react';
import { Button, HomeIcon } from '../../atoms';
import { NativeBaseProvider } from 'native-base';
import { fullAppTheme } from '../../../../shared';
export default /*#__PURE__*/memo(_ref => {
  let {
    onPress
  } = _ref;
  return /*#__PURE__*/React.createElement(NativeBaseProvider, {
    theme: fullAppTheme
  }, /*#__PURE__*/React.createElement(Button, {
    accessibilityLabel: "return to home",
    testID: "id_return_to_home",
    variant: "ghost",
    leftIcon: /*#__PURE__*/React.createElement(HomeIcon, null),
    w: "50",
    _text: {
      color: 'blue.500',
      textTransform: 'uppercase'
    },
    onPress: onPress
  }, "return to home"));
});
//# sourceMappingURL=ReturnToHome.js.map